export const DEFAULT_SIZE_ICON = 24